import gql from "graphql-tag";

export const getVacancies = gql`
  query getVacancies(
    $_search: String = ""
    $region: String = ""
    $schedule: ID = ""
    $experience: ID = ""
    $employment: ID = ""
    $area: ID = ""
  ) {
    vacancies(
      first: 1000
      where: {
        AND: {
          _search: $_search
          regions_some: { title_contains: $region }
          schedule: { id_contains: $schedule }
          experience: { id_contains: $experience }
          employment: { id_contains: $employment }
          area: { id_contains: $area }
        }
      }
    ) {
      id
      title
      area {
        title
      }
      experience {
        title
      }
      employment {
        title
      }
      schedule {
        title
      }
      salaryOption
      minimalSalary
      maximalSalary
      description
      duties
      requirements
      proposal
    }
  }
`;
